export default {
  methods: {
    getAnswer(answer) {
      return {
        ...answer,
        chiefComplaintId: answer?.chiefComplaintId?.id,
      };
    },
    setColors(rank) {
      switch (rank) {
        case 0:
          return {
            color: '#EFEFEF',
            textColor: '#565656',
            alternativeColor: '#EFEFEF',
          };
        case 1:
          return {
            color: '#EBFFF4',
            textColor: '#3BCA79',
          };
        case 2:
          return {
            color: '#FFFAEC',
            textColor: '#F2BD27',
          };
        case 3:
          return {
            color: '#FFF1F1',
            textColor: '#F56060',
          };
        default:
          return {};
      }
    },
    transformedALlAnswersList(allAnswersList) {
      //
      return [...allAnswersList]?.map(({ ...rest }) => {
        delete rest?.chiefComplaint;
        return {
          ...rest,
          ...this.setColors(rest.rank),
        };
      });
    },
    transformedAllSelectedAnswers(selectedAnswersList) {
      return [...selectedAnswersList]?.map(({ id }) => {
        return {
          answerId: id,
        };
      });
    },
  },
};
